import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-app px-4">
      <div className="text-center">
        <p className="text-sm font-medium text-ink">Page not found</p>
        <Link
          to="/"
          className="mt-2 inline-block text-xs text-accent underline-offset-2 hover:underline"
        >
          Go back
        </Link>
      </div>
    </div>
  );
}
